export default __webpack_public_path__ + "static/media/team42.7b8ebd32.JPG";